import { defineMessages as dm } from "react-intl";

interface Message {
  id: string;
  defaultMessage: string;
}

export const defineMessages = <
  T extends Record<string, string | Record<string, string>>
>(
  scope: string,
  messages: T
): {
  [K in keyof T]: T[K] extends string ? Message : Record<keyof T[K], Message>;
} =>
  dm(
    Object.entries<string | Record<string, string>>(messages).reduce(
      (a, [key, message]) => {
        if (typeof message === "object") {
          // assume message is in format of { subkey: str } structure
          a[key] = {};
          Object.entries(message).forEach(([subkey, submessage]) => {
            a[key][subkey] = {
              id: `${scope}.${key}.${subkey}`,
              defaultMessage: submessage,
            };
          });
        } else {
          a[key] = {
            id: `${scope}.${key}`,
            defaultMessage: message,
          };
        }
        return a;
      },
      {}
    )
  );
